import {useEffect, useState} from 'react';

export const useWindowsDimension = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 880)
    const [isSmallDesktop, setIsSmallDesktop] = useState(window.innerWidth <= 1200 && window.innerWidth > 880)

    useEffect(() => {
        const handleResize = () => {
            const currentIsMobile = window.innerWidth <= 880
            setIsMobile(currentIsMobile)
            const currentIsSmallDesktop = window.innerWidth <= 1200 && window.innerWidth > 880
            setIsSmallDesktop(currentIsSmallDesktop)
        }
        
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    return {
        isMobile,
        isSmallDesktop
    }
}